
import { supabase } from '@/integrations/supabase/client';

/**
 * Create a checkout session with Stripe
 * @param plan The subscription plan to check out
 * @returns The checkout session data including URL
 */
export const createCheckoutSession = async (plan: string) => {
  try {
    const { data, error } = await supabase.functions.invoke('create-checkout', {
      body: { plan }
    });

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
};

/**
 * Access the Stripe customer portal
 * @returns The customer portal session data including URL
 */
export const accessCustomerPortal = async () => {
  try {
    const { data, error } = await supabase.functions.invoke('customer-portal');
    
    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error accessing customer portal:', error);
    throw error;
  }
};

/**
 * Check the subscription status via Stripe
 * @returns The subscription status data
 */
export const checkSubscriptionStatus = async () => {
  try {
    const { data, error } = await supabase.functions.invoke('check-subscription');
    
    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error checking subscription status:', error);
    throw error;
  }
};
